import React, {
  useState,
  useEffect,
  useMemo,
  Fragment,
  useRef,
  useContext,
} from "react";
import api from "../api/axios";
import "./Scss/ClientStyles.scss?v=1.1.3";
// Animations
import {
  Alert,
  Autocomplete,
  Collapse,
  Fade,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import ReactPaginate from "react-paginate";
// MANUAL COMPONENTS
import Layout from "../Components/Common/Layout";
import Table from "../Components/Common/Table/Table";
// FUNCTIONS
import { CircularProgress, Button } from "@mui/material/";

import "../styles/App.scss?v=1.1.9";

import {
  CommonSubHeader,
  getInfoMessageNoResultsSearch,
} from "../Components/helpers/Helpers";
import LoadingPage from "../Components/Common/Loading/LoadingPage";
import { RenderCell } from "../Components/Common/Table/RenderCell";
import {
  CleaningServices,
  KeyboardArrowDown,
  KeyboardArrowUp,
  PersonAdd,
  Search,
  Visibility,
} from "@mui/icons-material";
import TableActions from "../Components/Common/Table/TableActions";
import { PermissionContext, UserContext } from "../Components/Context/Context";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Unauthorized from "../Components/Common/Design/Unauthorized";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { CustomButtonPlusIcon } from "../Components/Common/Design/CustomButtonPlusIcon";
import dayjs from "dayjs";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function Clientes(props) {
  const mountedRef = useRef(true);

  const [dateFromDefault, setDateFromDefault] = useState();
  const [dateToDefault, setDateToDefault] = useState();
  const [dateFromRangeFilter, setDateFromRangeFilter] = useState(null);
  const [dateToRangeFilter, setDateToRangeFilter] = useState(null);

  // SweetAlert
  const Swal = require("sweetalert2");

  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const handleSort = (column, direction) => {
    setSortColumn(column);
    setSortDirection(direction);
    setPagePressed(1); // reinicia paginación
  };

  const { userData } = useContext(UserContext);
  const { user } = userData;
  const { can } = useContext(PermissionContext);
  const hasPermission = can("clients", "view");
  const navigate = useNavigate();
  const [showFilters, setShowFilters] = useState(true);

  const [client, setClient] = useState([]);
  const [objPerPage, setObjPerPage] = useState(10);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pagePressed, setPagePressed] = useState(1);
  const [flag, setFlag] = useState(false);
  const [dataNoResults, setDataNoResults] = useState(false);
  const [search, setSearch] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({});

  // Columns data input filters
  const [lawyersData, setLawyersData] = useState({
    name: "",
    surname: "",
    id: 0,
  });
  const [statusId, setStatusId] = useState(0);
  const [company, setCompany] = useState({
    company_name: "Seleccionar",
    id: 0,
  });

  const [association, setAssociation] = useState({
    asoc_name: "Seleccionar",
    id: 0,
  });

  const [queryProvinceName, setQueryProvinceName] = useState(false);
  const [queryName, setQueryName] = useState(false);
  const [querySurname, setQuerySurname] = useState(false);
  const [queryPhone, setQueryPhone] = useState(false);
  const [queryEmail, setQueryEmail] = useState(false);
  const [queryObjPerPage, setQueryObjPerPage] = useState(false);

  const [provinceFilter, setProvinceFilter] = useState(0);
  const [nameFilter, setNameFilter] = useState(0);
  const [surnameFilter, setSurnameFilter] = useState(0);
  const [phoneFilter, setPhoneFilter] = useState(0);
  const [emailFilter, setEmailFilter] = useState(0);
  const [allLawyers, setAllLawyers] = useState([]);
  const [allAssociations, setAllAssociations] = useState([]);

  // DATEPICKER
  const [stateColumn, setStateColumn] = useState(0);

  // LISTAS PARA SELECTS FILTERS
  const [optionsStatus, setOptionsStatus] = useState([]);
  const [optionsLawyers, setOptionsLawyers] = useState([]);
  const [optionsCompanies, setOptionsCompanies] = useState([]);
  const [optionsAssociations, setOptionsAssociations] = useState([]);

  const [changeDone, setChangeDone] = useState(false);

  const handlePageClick = (event) => {
    setPagePressed(event.selected + 1);
  };

  const getDataClients = async () => {
    setFlag(true);

    try {
      if (objPerPage >= 500) {
        Swal.fire({
          icon: "warning",
          title: "Carga de registros extensa",
          text: "Ha seleccionado un volumen elevado de registros. El proceso de carga puede tardar algunos segundos, le agradecemos su paciencia mientras se completan los archivos.",
          confirmButtonText: "Aceptar",
        });
      }

      const response = await api.post(
        process.env.REACT_APP_API_URL + "/users",
        {
          page: pagePressed,
          objPerPage,
          sortColumn,
          sortDirection,
          date_from_range: dateFromRangeFilter,
          date_to_range: dateToRangeFilter,
          ...appliedFilters,
        },
      );

      const { clients, companies, associations, lawyers } = response.data;

      const clientsData = clients.data.map((client) => ({
        ...client,
        lawyers_fullname:
          client.lawyers_relation?.id !== 0
            ? `${client.lawyers_relation?.name} ${client.lawyers_relation?.surname}`
            : null,
        client_fullname:
          client.name || client.surname
            ? `${client.name} ${client.surname}`
            : null,
      }));

      updateOptions(companies, lawyers, associations);

      setPageCount(clients.last_page);
      setTotalPagesNumber(clients.total);
      setClient(clientsData);
    } catch (error) {
      console.error("ERROR AXIOS:", error);

      if (error.response) {
        console.error("STATUS:", error.response.status);
        console.error("DATA:", error.response.data);
        console.error("HEADERS:", error.response.headers);
      } else if (error.request) {
        console.error("NO RESPONSE:", error.request);
      } else {
        console.error("REQUEST ERROR:", error.message);
      }
    } finally {
      setFlag(false);
    }
  };

  const handleFilterStates = () => {
    setLawyersData({
      name: "",
      surname: "",
    });
    setCompany({ company_name: "Seleccionar", id: 0 });
    setAssociation({ asoc_name: "Seleccionar", id: 0 });
    setStatusId({ nombre: "Seleccionar", id: 0 });

    // MANEJO DE FILTROS
    setQueryName(false);
    setQuerySurname(false);
    setQueryPhone(false);
    setQueryEmail(false);
    setQueryProvinceName(false);

    setProvinceFilter(0);
    setNameFilter(0);
    setSurnameFilter(0);
    setPhoneFilter(0);
    setEmailFilter(0);
    setAppliedFilters({});
    setPagePressed(1);

    setClient([]);

    setDateFromDefault(null);
    setDateToDefault(null);
    setDateFromRangeFilter(null);
    setDateToRangeFilter(null);
    // MANEJO DE FILTROS

    setSearch(!search);
  };

  const triggerSearchOnEnter = (event) => {
    if (event?.key === "Enter") {
      event.preventDefault();
      applyFilters();
    }
  };

  // Función para actualizar las opciones
  const updateOptions = (companies, lawyers, associations) => {
    companies.unshift({ company_name: "Seleccionar", id: 0 });

    const arrayToStatus = [
      { nombre: "Seleccionar", id: 0 },
      { nombre: "Activo", id: 1 },
      { nombre: "Inactivo", id: -1 },
    ];

    setOptionsCompanies(companies);
    setOptionsStatus(arrayToStatus);

    // Guardamos originales
    setAllLawyers(lawyers);
    setAllAssociations(associations);

    // Inicialmente sin filtrar
    setOptionsLawyers([
      { name: "Seleccionar", surname: "", id: 0 },
      ...lawyers,
    ]);

    setOptionsAssociations([
      { asoc_name: "Seleccionar", id: 0 },
      ...associations,
    ]);
  };

  const applyFilters = () => {
    const filters = {};

    if (lawyersData?.id) filters.lawyer_id = lawyersData.id;
    if (company?.id) filters.company_id = company.id;
    if (association?.id) filters.association_id = association.id;
    if (statusId?.id !== undefined && statusId?.id !== 0)
      filters.status = statusId.id;

    if (provinceFilter) filters.province = provinceFilter;
    if (nameFilter) filters.name = nameFilter;
    if (surnameFilter) filters.surname = surnameFilter;
    if (phoneFilter) filters.phone = phoneFilter;
    if (emailFilter) filters.email = emailFilter;

    setAppliedFilters(filters);
    setSearch(!search);
  };

  // Initial client table information
  useEffect(() => {
    if (!hasPermission) return;

    getDataClients();
  }, [
    objPerPage,
    pagePressed,
    appliedFilters,
    changeDone,
    search,
    sortColumn,
    sortDirection,
  ]);

  useEffect(() => {
    if (typeof queryName == "string") {
      setNameFilter(queryName);
    }
  }, [queryName]);

  useEffect(() => {
    if (typeof querySurname == "string") {
      setSurnameFilter(querySurname);
    }
  }, [querySurname]);

  useEffect(() => {
    if (typeof queryPhone == "string") {
      setPhoneFilter(queryPhone);
    }
  }, [queryPhone]);

  useEffect(() => {
    if (typeof queryEmail == "string") {
      setEmailFilter(queryEmail);
    }
  }, [queryEmail]);

  useEffect(() => {
    if (typeof queryProvinceName == "string") {
      setProvinceFilter(queryProvinceName);
    }
  }, [queryProvinceName]);

  useEffect(() => {
    if (typeof queryObjPerPage === "number") {
      if (totalPagesNumber < queryObjPerPage) {
        setObjPerPage(totalPagesNumber);
      } else {
        setObjPerPage(queryObjPerPage);
      }
    }
  }, [queryObjPerPage]);

  useEffect(() => {
    if (!company || !company.id || company.id === 0) {
      setOptionsLawyers([
        { name: "Seleccionar", surname: "", id: 0 },
        ...allLawyers,
      ]);

      // setOptionsAssociations([
      //   { asoc_name: "Seleccionar", id: 0 },
      //   ...allAssociations,
      // ]);

      return;
    }

    const filteredLawyers = allLawyers.filter(
      (lawyer) => lawyer.company_id === company.id,
    );

    // const filteredAssociations = allAssociations.filter(
    //   (assoc) => assoc.company_id === company.id,
    // );

    setOptionsLawyers([
      { name: "Seleccionar", surname: "", id: 0 },
      ...filteredLawyers,
    ]);

    // setOptionsAssociations([
    //   { asoc_name: "Seleccionar", id: 0 },
    //   ...filteredAssociations,
    // ]);

    // Limpiamos selección actual si cambia empresa
    setLawyersData({ name: "", surname: "", id: 0 });
    // setAssociation({ asoc_name: "Seleccionar", id: 0 });
  }, [
    company,
    allLawyers,
    // allAssociations
  ]);

  const renderStatus = (value) => {
    const estado = value;
    const estadoMap = {
      0: "Inactivo",
      1: "Activo",
    };
    return (
      <div className="spanClassForTables centerContent">
        {estadoMap[estado] || "Sin asignar"}
      </div>
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: "LISTA DE CLIENTES",
        columns: [
          {
            Header: <span>Abogado</span>,
            accessor: "lawyers_fullname",
            sortField: "lawyer",
            minWidth: 250,
            Cell: ({ row, value }) => (
              <Box
                sx={{
                  justifyContent: "left",
                  textAlign: "left",
                }}
              >
                <Button
                  component="a"
                  href={`/clientes/ver?id=${row?.original?.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  startIcon={<Visibility />}
                  variant="text"
                  sx={{
                    textTransform: "none",
                    justifyContent: "center",
                    fontSize: "inherit",
                    paddingLeft: "30px",
                    minWidth: 0,
                    "& .MuiButton-startIcon": { fontSize: "inherit" },
                    "&:hover": { backgroundColor: "transparent" },
                  }}
                >
                  <RenderCell value={value} defaultValue="Sin asignar" blank />
                </Button>
              </Box>
            ),
          },
          {
            minWidth: 170,
            Header: "Empresa",
            sortField: "company_id",
            accessor: "company_relation.company_name",
            Cell: ({ value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Asociación",
            sortField: "asoc_name",
            accessor: "asociations_relation.asoc_name",
            minWidth: 170,
            Cell: ({ value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Provincia",
            sortField: "province",
            accessor: "province",
            minWidth: 100,
            Cell: ({ value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Nombre y Apellidos",
            sortField: "name",
            accessor: "client_fullname",
            minWidth: 200,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Teléfono",
            sortField: "phone",
            accessor: "phone",
            minWidth: 120,
            Cell: ({ value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Email",
            sortField: "email",
            accessor: "email",
            minWidth: 174,
            Cell: ({ value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Estado",
            sortField: "status",
            accessor: "status",
            minWidth: 110,
            Cell: ({ value }) => renderStatus(value),
          },
          {
            Header: "Última conexión",
            sortField: "last_login",
            accessor: "last_login",
            minWidth: 200,
            Cell: ({ value }) => (
              <RenderCell value={value} dateFlag={true} view="clientes" />
            ),
          },
          {
            Header: "Acciones",
            accessor: "id",
            minWidth: 174,
            Cell: ({ value, row }) => (
              <TableActions
                rute={"clientes"}
                apiRute={"users"}
                module={"clients"}
                completeValue={row.original}
                value={value}
                userLogged={user}
                showView
                showEdit
                showDelete
                showTransfer
                textTransfer={"expedientes"}
                setChangeDone={setChangeDone}
                changeDone={changeDone}
              />
            ),
          },
        ],
      },
    ],
    [],
  );

  // FILTER FIELDS
  const fieldsConfig = [
    {
      grid: { md: 2, xs: 12 },
      type: "autocomplete",
      label: "Abogado:",
      className: "assignToId",
      value: lawyersData,
      options: optionsLawyers,
      disabled: company.id === 0,
      getOptionLabel: (option) =>
        option?.name ? `${option.name} ${option.surname || ""}` : "",
      onChange: (event, value) =>
        value
          ? setLawyersData({
              name: value.name,
              surname: value.surname,
              id: value.id,
            })
          : setLawyersData({ name: "Seleccionar", surname: "" }),
      isOptionEqualToValue: (option, value) => option.id === value.id,
    },
    {
      grid: { md: 2, xs: 12 },
      type: "autocomplete",
      label: "Empresa",
      className: "companyId",
      value: company,
      options: optionsCompanies,
      getOptionLabel: (option) => option?.company_name || "",
      onChange: (event, value) =>
        setCompany(
          value && value.id !== undefined
            ? value
            : { company_name: "Seleccionar", id: 0 },
        ),
      isOptionEqualToValue: (option, value) => option.id === value.id,
    },
    {
      grid: { md: 2, xs: 12 },
      type: "autocomplete",
      label: "Asociaciones",
      className: "asociationsId",
      // disabled: !company?.id || company.id === 0,
      value: association,
      options: optionsAssociations,
      getOptionLabel: (option) => option?.asoc_name || "",
      onChange: (event, value) =>
        setAssociation(value ?? { asoc_name: "Seleccionar", id: 0 }),
      isOptionEqualToValue: (option, value) => option.id === value.id,
    },
    {
      grid: { md: 2, xs: 12 },
      type: "autocomplete",
      label: "Estado",
      className: "statusId",
      value: statusId,
      options: optionsStatus,
      getOptionLabel: (option) => option?.nombre || "",
      onChange: (event, value) => setStatusId(value?.id ? value : null),
      isOptionEqualToValue: (option, value) => option?.nombre === value?.nombre,
    },
    {
      grid: { md: 2, xs: 12 },
      type: "text",
      value: queryProvinceName == 0 ? "" : provinceFilter,
      label: "Provincia",
      onChange: (e) => setProvinceFilter(e.target.value),
    },
    {
      grid: { md: 2, xs: 12 },
      type: "text",
      value: queryName == 0 ? "" : nameFilter,
      label: "Nombre cliente",
      onChange: (e) => setQueryName(e.target.value),
    },
    {
      grid: { md: 2, xs: 12 },
      type: "text",
      value: querySurname == 0 ? "" : surnameFilter,
      label: "Apellido cliente",
      onChange: (e) => setQuerySurname(e.target.value),
    },
    {
      grid: { md: 2, xs: 12 },
      type: "text",
      value: queryPhone == 0 ? "" : phoneFilter,
      label: "Teléfono",
      onChange: (e) => setQueryPhone(e.target.value),
    },
    {
      grid: { md: 2, xs: 12 },
      type: "text",
      value: queryEmail == 0 ? "" : emailFilter,
      label: "Email",
      onChange: (e) => setQueryEmail(e.target.value),
    },
    {
      type: "dateRange",
      grid: { xs: 12, md: 4 },
      items: [
        {
          label: "Fecha entrada desde",
          value: dateFromDefault ? dayjs(dateFromDefault) : null,
          onChange: (date) => handleChangeDateFromRange(date),
          sx: {
            width: "50%",
            "& fieldset": {
              borderRight: "none",
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
              height: "36px",
            },
          },
          className: "rangeFilterDateLeft",
        },
        {
          label: "Fecha entrada hasta",
          value: dateToDefault ? dayjs(dateToDefault) : null,
          onChange: (date) => handleChangeDateToRange(date),
          sx: {
            width: "50%",
            "& fieldset": {
              borderLeft: "none",
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              height: "36px",
            },
          },
          className: "rangeFilterDateRight",
        },
      ],
    },
    {
      type: "select",
      grid: { xs: 4, md: 2 },
      sxGrid: {
        ml: { md: "auto" },
      },
      label: "Nº Registros",
      value: objPerPage,
      options: [10, 20, 30, 100, 200, 500, 1000, 2000],
      onChange: (e) => {
        setObjPerPage(Number(e.target.value));
        setPagePressed(1);
      },
    },
  ];

  const handleChangeDateFromRange = (dateFrom) => {
    // console.log(dateFrom); // Verifica si esto es un objeto dayjs
    if (dateFrom && dayjs.isDayjs(dateFrom)) {
      // Convierte el objeto dayjs a un string
      const formattedDate = dateFrom.format("YYYY-MM-DD 00:00:00");
      setDateFromDefault(dateFrom); // Guarda solo la fecha como string
      setDateFromRangeFilter(formattedDate); // Guarda solo la fecha como string
    } else {
      setDateFromRangeFilter(null);
    }
  };

  const handleChangeDateToRange = (dateTo) => {
    // console.log(dateTo); // Verifica si esto es un objeto dayjs
    if (dateTo && dayjs.isDayjs(dateTo)) {
      // Convierte el objeto dayjs a un string
      const formattedDate = dateTo.format("YYYY-MM-DD 23:59:59");
      setDateToDefault(dateTo); // Guarda solo la fecha como string
      setDateToRangeFilter(formattedDate); // Guarda solo la fecha como string
    } else {
      setDateToRangeFilter(null);
    }
  };

  useEffect(() => {
    if (pagePressed > pageCount) {
      setPagePressed(1);
    }
  }, [pageCount]);

  const filterInputSx = {
    "& .MuiOutlinedInput-root": {
      height: "36px",
    },
    "& .MuiInputBase-root": {
      height: "34px !important",
    },
  };

  const content = (
    <div className="mainContainer">
      <div className="subMainContainer">
        <Box
          sx={{
            position: "relative",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,1) 100%)",
            marginBottom: "33px",
            mx: "10px",
            borderRadius: "14px",
            border: "1px solid rgba(245, 158, 11, 0.12)",
            boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              px: { xs: 1.2, md: 1.6 },
              py: 1,
              background:
                "linear-gradient(90deg, rgba(245,158,11,0.08) 0%, rgba(255,255,255,0.96) 68%)",
              borderBottom: "1px solid rgba(245, 158, 11, 0.1)",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                color: "#9a4a00",
                letterSpacing: "0.03em",
              }}
            >
              Filtros de búsqueda
            </Typography>

            <Button
              variant="outlined"
              size="small"
              onClick={() => setShowFilters(!showFilters)}
              endIcon={
                showFilters ? <KeyboardArrowUp /> : <KeyboardArrowDown />
              }
              sx={{
                minWidth: { xs: "36px", sm: "156px" },
                width: { xs: "36px", sm: "auto" },
                height: "30px",
                px: { xs: 0.25, sm: 1.2 },
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.78rem",
                borderColor: "rgba(245, 158, 11, 0.24)",
                color: "#92400e",
                backgroundColor: "rgba(255,255,255,0.86)",
                transition:
                  "all 220ms cubic-bezier(0.22,1,0.36,1), box-shadow 220ms cubic-bezier(0.22,1,0.36,1)",
                "& .MuiButton-endIcon": {
                  marginLeft: { xs: 0, sm: 0.5 },
                  marginRight: 0,
                },
                "&:hover": {
                  borderColor: "rgba(245, 158, 11, 0.42)",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 4px 12px rgba(245, 158, 11, 0.14)",
                },
              }}
            >
              <Box
                component="span"
                sx={{ display: { xs: "none", sm: "inline" } }}
              >
                {showFilters ? "Ocultar filtros" : "Mostrar filtros"}
              </Box>
            </Button>
          </Box>

          <Collapse in={showFilters} timeout={400}>
            <Grid
              container
              className="filtersContainer"
              sx={{
                px: { xs: 0.75, md: 1.15 },
                py: 0.95,
                rowGap: 0.05,
                backgroundColor: "transparent",
              }}
            >
              {fieldsConfig.map((field, index) => {
                return (
                  <Grid
                    item
                    {...field.grid}
                    key={index}
                    textAlign="left"
                    sx={{ padding: "5px" }}
                  >
                    {/* AUTOCOMPLETE */}
                    {field.type === "autocomplete" && (
                      <Autocomplete
                        className={field.className}
                        size="small"
                        onChange={field.onChange}
                        options={field.options}
                        disabled={field.disabled}
                        isOptionEqualToValue={field.isOptionEqualToValue}
                        getOptionLabel={field.getOptionLabel}
                        value={field.value}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={field.label}
                            autoComplete="off"
                            sx={filterInputSx}
                            onKeyDown={triggerSearchOnEnter}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <Fragment>
                                  {field.loading && (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  )}
                                  {params.InputProps.endAdornment}
                                </Fragment>
                              ),
                              form: {
                                autoComplete: "off",
                              },
                            }}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: "new-password",
                            }}
                          />
                        )}
                      />
                    )}

                    {/* DATE RANGE */}
                    {field.type === "dateRange" && (
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="es"
                      >
                        {field.items.map((item, idx) => (
                          <DesktopDatePicker
                            key={idx}
                            sx={item.sx}
                            disabled={field.disabled}
                            label={item.label}
                            value={item.value}
                            onChange={item.onChange}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                className={item.className}
                                style={{
                                  width: "50%",
                                }}
                                onKeyDown={triggerSearchOnEnter}
                              />
                            )}
                          />
                        ))}
                      </LocalizationProvider>
                    )}

                    {/* DEFAULT INPUT */}
                    {field.type !== "autocomplete" &&
                      field.type !== "dateRange" &&
                      field.type !== "select" && (
                        <TextField
                          onChange={field.onChange}
                          label={field.label}
                          value={field.value}
                          sx={filterInputSx}
                          variant="outlined"
                          autoComplete="new-password"
                          size="small"
                          fullWidth
                          onKeyDown={triggerSearchOnEnter}
                        />
                      )}

                    {field.type === "select" && (
                      <FormControl
                        fullWidth
                        size="small"
                        sx={filterInputSx}
                        disabled={field?.disabled}
                      >
                        <InputLabel>{field.label}</InputLabel>
                        <Select
                          value={field.value}
                          label={field.label}
                          onChange={field.onChange}
                          sx={filterInputSx}
                        >
                          {field.options.map((num) => (
                            <MenuItem key={num} value={num}>
                              {num}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                );
              })}

              {/* BOTONES */}
              <Grid
                item
                xs={12}
                md={12}
                textAlign="center"
                sx={{
                  display: "inline-flex",
                  gap: "5px",
                  justifyContent: "center",
                }}
              >
                <CustomButtonPlusIcon
                  icon={Search}
                  text={"BUSCAR"}
                  handleFunction={applyFilters}
                  position={"start"}
                  variant={"outlined"}
                  color={"info"}
                />
                <CustomButtonPlusIcon
                  icon={CleaningServices}
                  text={"LIMPIAR FILTROS"}
                  handleFunction={handleFilterStates}
                  position={"start"}
                  variant={"outlined"}
                  color={"error"}
                />
              </Grid>
            </Grid>
          </Collapse>

          {/* BOTÓN FLOTANTE */}
          <Box
            sx={{
              position: "absolute",
              bottom: showFilters ? "-26px" : "-16px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              onClick={() => setShowFilters(!showFilters)}
              endIcon={
                showFilters ? <KeyboardArrowUp /> : <KeyboardArrowDown />
              }
              sx={{
                minWidth: "220px",
                height: "25px",
                borderRadius: "0px 0px 10px 10px",
                boxShadow: 3,
                textTransform: "none",
                fontWeight: 500,
              }}
            >
              {showFilters ? "Ocultar filtros" : "Mostrar filtros"}
            </Button>
          </Box>
        </Box>
        <Fade timeout={600} in>
          <div>
            {flag && hasPermission && (
              <LoadingPage isLoading={true} heightProp={"60vh"} />
            )}
            {!flag && (
              <div>
                <Table
                  columns={columns}
                  data={client}
                  view={"cliente"}
                  viewTitle={"clientes"}
                  totalPagesNumber={totalPagesNumber}
                  icon={PersonAdd}
                  viewPermission={"users"}
                  apiRoute={"users"}
                  // pagination
                  onPageChange={handlePageClick}
                  pageCount={pageCount}
                  forcePage={pagePressed - 1} // Esto sincroniza el botón activo
                  // SORT
                  onSort={handleSort}
                  sortColumn={sortColumn}
                  sortDirection={sortDirection}
                  objPerPage={objPerPage}
                />
              </div>
            )}
          </div>
        </Fade>
      </div>
    </div>
  );

  // SEARCH BUTTON
  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Clientes" />

      {!hasPermission && <Unauthorized />}

      {hasPermission && content}
    </div>
  );
}

export default Clientes;
